import { Col } from "@/common/css";
import Button from "@/common/ui/Button";
import { Container } from "@/common/ui/container";
import { LightText2 } from "@/common/ui/Text";
import React from "react";

interface AttentionProps {
  onClose: (props?: any) => void;
}

const Attention: React.FC<AttentionProps> = ({ onClose }) => {
  return (
    <Container.ContentBox>
      <Container.Content className="py-3 px-4">
        <Col className="">
          <LightText2 text={"A minimum of one signatory is required. Please add another signatory before proceeding with the deletion."} className="" />
        </Col>
      </Container.Content>
      <Container.Separator />
      <div className={`flex justify-end gap-4 w-full p-4`}>
        <Button variant="outline" size="small" onClick={onClose}>
          Cancel
        </Button>
      </div>
    </Container.ContentBox>
  );
};

export default Attention;
